// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__20VCt","rootSuccess":"CompleteLink_rootSuccess__1kReK","rootFailure":"CompleteLink_rootFailure__1xusR","isDisabled":"CompleteLink_isDisabled__3zwvk"};